import React, { useState } from "react";
import Slider from "react-slick";
import OngoingProject from "./OngoingProject";

const AuthorityOngoingProject = ({ data }) => {
  const projectsPerPage = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastProject = currentPage * projectsPerPage;
  const totalPages = Math.ceil(data.length / projectsPerPage);
  const indexOfFirstProject = indexOfLastProject - projectsPerPage;
  const currentProjects = data.slice(indexOfFirstProject, indexOfLastProject);

  // const handleNextPage = () => {
  //   setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  // };

  // const handlePrevPage = () => {
  //   setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  // };

  // const handlePageClick = (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  // const renderPageNumbers = () => {
  //   const pageNumbers = [];
  //   for (let i = 1; i <= totalPages; i++) {
  //     pageNumbers.push(
  //       <button
  //         key={i}
  //         className={`mx-[3px] page-number ${currentPage === i ? "active" : ""}`}
  //         onClick={() => handlePageClick(i)}
  //       >
  //         {i}
  //       </button>
  //     );
  //   }
  //   return pageNumbers;
  // };

  const settings = {
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 2,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024, // Large screens
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Tablets
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="w-full flex-col justify-center items-center mx-auto max-sm:pl-0 md:pl-0">
      <div className="max-w-[96vw]  mx-auto"></div>
      <Slider {...settings}>
        {currentProjects.map((d, index) => (
          <div
            key={index}
            className="pb-2  max-w-[400px] mx-auto rounded-xl  text-gray-700"
          >
            <div className="cards pt-1 pb-2 rounded-t-xl">
              <div className="flex mt-2 justify-center">
                <img
                  className="card-img h-[240px] max-md:h-[200px] w-[96%] rounded-lg object-cover"
                  src={d.img}
                  alt=""
                />
              </div>
            </div>
            <div className="border-b-2 border-x-2 rounded-b-xl border-gray-400 ">
              <p className="text-left py-2 pl-5 font-bold text-lg ">
                Project Name: <span className="font-thin text  text-[17px] ml-1">{d.NameOfProject}</span>
              </p>
              <p className="text-left py-2 pl-5 font-bold text-lg">
                Service: <span className="font-thin text-[17px] ml-1">{d.ScopeofWork}</span>
              </p>
              <p className="text-left py-2 pl-5 font-bold text-lg">
                Client: <span className="font-thin text-[17px] ml-1">{d.Client}</span>
              </p>
              <p className="text-left py-2 pl-5 font-bold text-lg">
                Cost: <span className="font-thin text-[17px] ml-1">{d.Cost}</span>
              </p>
              <p className="text-left py-2 pl-5 font-bold text-lg">
                Status: <span className="font-thin text-[17px] ml-1">{d.Status}</span>
              </p>
            </div>
          </div>
        ))}
      </Slider>

      <div>
        <OngoingProject status="Running" />

      </div>
    </div>

  );
};

export default AuthorityOngoingProject;
